import styled from 'styled-components'
import { media } from '@popety-io/ui'

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.large};
  padding: ${({ theme }) => theme.spacing.large};
  max-width: 1200px;

  ${media.mobileOnly} {
    padding: ${({ theme }) => theme.spacing.medium};
    gap: ${({ theme }) => theme.spacing.medium};
  }
`

export const SectionCard = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.spacing.large};
  border: 1px solid ${({ theme }) => theme.colors.border.default};

  ${media.mobileOnly} {
    padding: ${({ theme }) => theme.spacing.medium};
  }
`

export const SectionTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 ${({ theme }) => theme.spacing.medium} 0;
`

export const ChartContainer = styled.div`
  min-height: 300px;
`

export const FinalValuationCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.spacing.large};
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
`

export const ValuationValue = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.hero};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.primary};

  ${media.mobileOnly} {
    font-size: ${({ theme }) => theme.typography.fontSize.title};
  }
`

export const ValuationRange = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const PricePerSqmLine = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  flex-wrap: wrap;
`

export const NoDataMessage = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing.xlarge};
  color: ${({ theme }) => theme.colors.text.secondary};
`
